import { setStorage, getStorage } from '@utils/localStorage';

/** 校验浏览器是否支持webp */
const checkWebp = () => {
    if (!getStorage('hasSupportWebp')) {
        const img = new Image();
        img.onload = function() {
            setStorage('hasSupportWebp', 'true');
        };
        img.onerror = function() {
            setStorage('hasSupportWebp', 'false');
        };
        img.src = '/static/imgs/dl_code.webp';
    }
};

export default checkWebp;
